import HStack from '~/common/components/Stacks/HStack';
import Text from '~/common/components/Texts/Text';
import DrawerHeader from '~/common/mui/Drawers/DrawerHeader';
import { formatCurrency } from '~/common/util/format';
import type { HistoricalCalculation } from '~/pages/IncomeCalculator/CalculationHistory/types';
import {
  isEmploymentIncome,
  useIncomeInformation,
} from '~/pages/IncomeCalculator/hooks';
import lang from '~/pages/IncomeCalculator/language.json';

import BackButton from './HistoricalBreakdown/components/BackButton';
import CalculationSummary from './components/CalculationSummary';

type HistoryDrawerHeader = {
  calculationInformation: HistoricalCalculation;
  onClose?: () => unknown;
  haveSelectedACalculation?: boolean;
};

const HistoryDrawerHeader = ({
  calculationInformation,
  onClose,
  haveSelectedACalculation = false,
}: HistoryDrawerHeader) => {
  const { data: selectedIncome } = useIncomeInformation();

  const isRentalIncome = !isEmploymentIncome(selectedIncome);

  const showSelectedCalculationHeader =
    haveSelectedACalculation && !!calculationInformation;

  const amountToHighlight = isRentalIncome
    ? calculationInformation?.rentalIncomePitia
    : calculationInformation?.calculatedMonthlyAmount;

  return (
    <DrawerHeader>
      {!haveSelectedACalculation && (
        <>
          <Text fontSize="2xl" fontWeight={600} mb={2}>
            {lang.CALC_HISTORY}
          </Text>
          <Text fontWeight={400} fontSize="md">
            {isRentalIncome
              ? selectedIncome.propertyData.propertyName
              : selectedIncome.employerName}
          </Text>
          {isRentalIncome && (
            <Text fontWeight={400} fontSize="xs" pt={4} color="gray.600">
              {lang.CALC_HISTORY_PITIA}
            </Text>
          )}
          <Text fontWeight={600} fontSize="5xl">
            {formatCurrency(amountToHighlight)}
          </Text>
        </>
      )}
      {showSelectedCalculationHeader && (
        <>
          <BackButton onClose={onClose} />
          <HStack justifyContent="space-between">
            <CalculationSummary summary={calculationInformation} />
          </HStack>
        </>
      )}
    </DrawerHeader>
  );
};

export default HistoryDrawerHeader;
